import { render, staticRenderFns } from "./testimonials.html?vue&type=template&id=af358f7c&"
import script from "./testimonials.js?vue&type=script&lang=js&"
export * from "./testimonials.js?vue&type=script&lang=js&"
import style0 from "./testimonials.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports